export enum QualityDocumentOrderType {
  HOSP = "HOSP",
  IVO = "IVO",
  BelastningsregisterNationella = "BelastningsregisterNationella"
}
